export default __webpack_public_path__ + "static/media/paymentFail.4ad82bd6.svg";